export const ALL = 'ALL';
export const NONE = 'NONE';
